"use strict";

module.exports = {
    MODE_DATE: "date",
    MODE_DATETIME: "datetime",
    MODE_TIME: "time"
};


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-datetimepicker/lib/Constants.js
// module id = 95
// module chunks = 0